import React, { useEffect, useState } from "react";
// reactstrap components
import {
  Card,
  Container,
  CardHeader,
  CardBody,
  Table,
  Row,
  Col,
  Button,
  CustomInput,
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import { connect } from "react-redux";
import Unauthorized from "views/Pages/Unauthorized";
import {
  fetchPettyCashUsersListing,
  fetchPettyCashUsersListingSuccess,
} from "../../redux/PettyCashUsers/pettyCashUsersAction";
import { toast } from "react-toastify";
import { resetState } from "../../redux/common/commonAction";
import ConfirmationDeleteModal from "views/Modal/ConfirmationDeleteModal";
import { GetApiActionWithAuthorization } from "constantFunctions/apiActions";
import { PostApiWithAuthorizationAction } from "constantFunctions/apiActions";
import AddNewPettyCashUserModal from "views/Modal/PettyCashUsers/AddNewPettyCashUsersModal";
import EditPettyCashUsersModal from "views/Modal/PettyCashUsers/EditPettyCashUsersModal";

function PettyCashUsers(props) {
  const [unauthorized, setUnauthorized] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [confirm, setConfirm] = useState(false);
  const [delId, setDelId] = useState("");
  useEffect(() => {
    props.fetchPettyCashUsersListing();
  }, []);

  if (props.users.error && !unauthorized) {
    if (props.users.error.status === 403) {
      setUnauthorized(true);
    } else if (props.users.error.status === 440) {
      props.resetState();
      toast.error(props.users.error.message, {
        position: toast.POSITION.TOP_CENTER,
      });
      props.history.push("/auth/login");
    }
  }

  const toggleAdd = (e) => {
    setAddModal(!addModal);
  };

  const toggleEdit = (id = "", name = "") => {
    setEditData({ id, name });
    setEditModal(!editModal);
  };

  const toggleConfirm = (id = "") => {
    setDelId(id);
    setConfirm(!confirm);
  };

  const confirmed = (e) => {
    GetApiActionWithAuthorization("common/delete-petty-cash-user/" + delId)
      .then((res) => {
        props.addUpdatedData(res.data);
        //toast.success(res.message, { position: toast.POSITION.TOP_CENTER });
        setConfirm(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.status === 403) {
          setUnauthorized(true);
        } else if (err.status === 440) {
          props.resetState();
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
  };

  const changeOrder = (decrease, id, order) => {
    let body = { decrease, id, order,type:"petty_cash_user" };
    PostApiWithAuthorizationAction("common/change-order", body)
      .then((res) => {
        props.addUpdatedData(res.data);
      })
      .catch((err) => {
        if (err.status === 403) {
          setUnauthorized(true);
        } else if (err.status === 440) {
          props.resetState();
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
  };

  const renderTicketsTableData = (e) => {
    return props.users.allUsers.map((user, i) => {
      return (
        <tr key={i}>
          <td>
            [
            <span
            id={"update-user"+i}
              className="delete-item"
              onClick={(e) => {
                toggleEdit(user.id, user.name);
              }}
            >
              Edit
            </span>
            ] [
            <span
            id={"delete-user"+i}
            className="delete-item"
              onClick={(e) => toggleConfirm(user.id)}
            >
              Delete
            </span>
            ]{" "}
          </td>
          <td>{user.name}</td>
          <td className="display-order">
            <Button
            className="px-2 py-2"
              onClick={(e) => {
                if (i !== 0) {
                  changeOrder(true, user.id, user.displayOrder);
                }
              }}
            >
              <i className="fas fa-arrow-up"></i> Up
            </Button>
            <Button
            className="px-2 py-2"
            onClick={(e) => {
                if (i !== props.users.allUsers.length - 1) {
                  changeOrder(false, user.id, user.displayOrder);
                }
              }}
            >
              {" "}
              <i className="fas fa-arrow-down"></i> Down
            </Button>
          </td>
          {/* <td>
            <span
              className="delete-item"
              onClick={(e) => {
                toggleEdit(buyer.id, buyer.name);
              }}
            >
              Edit
            </span>
          </td> */}
        </tr>
      );
    });
  };

  return unauthorized ? (
    <Unauthorized />
  ) : (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--9 main-content" fluid>
        <Card className="card-height shadow">
          <CardHeader>
            <div className="text-center">
              <h1>Petty Cash Users</h1>
            </div>
          </CardHeader>
          <CardBody>
            <Row className="mb-3">
              <Col md="6" className="search-left-btn">
                <Button id="add-new" color="primary" onClick={toggleAdd}>
                  Add New+
                </Button>
              </Col>
            </Row>
            <Table className="ticket-table table-listing" responsive bordered>
              <thead className="thead-light">
                <tr>
                  <th scope="col">Action</th>
                  <th scope="col">Name</th>
                  <th scope="col">Order</th>
                </tr>
              </thead>
              <tbody>{renderTicketsTableData()}</tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>
      {addModal && (
        <AddNewPettyCashUserModal {...props} show={addModal} toggle={toggleAdd} />
      )}
      {editModal && (
        <EditPettyCashUsersModal
          {...props}
          show={editModal}
          editData={editData}
          toggle={toggleEdit}
        />
      )}
      {confirm && (
        <ConfirmationDeleteModal
          show={confirm}
          toggle={toggleConfirm}
          confirmed={confirmed}
        />
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    users: state.pettyCashUsersReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPettyCashUsersListing: () => dispatch(fetchPettyCashUsersListing()),
    addUpdatedData: (data) => dispatch(fetchPettyCashUsersListingSuccess(data)),
    resetState: () => dispatch(resetState()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PettyCashUsers);
